<script>
    export default {
        name: 'social-share',

        props: [
            'url',
            'title'
        ],

        data() {
            return {
                currentUrl:        window.location.href.split('?')[0],
                linkedInShareLink: 'https://www.linkedin.com/shareArticle?mini=true&url={articleUrl}&title={articleTitle}',
                twitterShareUrl:   'https://twitter.com/intent/tweet?url={articleUrl}&text={articleTitle}',
                facebookShareUrl:  'https://www.facebook.com/sharer/sharer.php?u={articleUrl}',
                googleShareUrl:    'https://plus.google.com/share?url={articleUrl}',
            }
        },

        methods: {
            shareOnLinkedIn() {
                const link = this.linkedInShareLink
                     .replace('{articleUrl}', encodeURIComponent(this.url))
                     .replace('{articleTitle}', encodeURIComponent(this.title))
                window.open(link, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
            },

            shareOnTwitter() {
                const link = this.twitterShareUrl
                     .replace('{articleUrl}', encodeURIComponent(this.url))
                     .replace('{articleTitle}', encodeURIComponent(this.title))
                window.open(link, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
            },

            shareOnFacebook() {
                const link = this.facebookShareUrl
                     .replace('{articleUrl}', encodeURIComponent(this.url))
                     .replace('{articleTitle}', encodeURIComponent(this.title))
                window.open(link, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
            },
            shareOnGoogle() {
                const link = this.googleShareUrl
                     .replace('{articleUrl}', encodeURIComponent(this.url))
                     .replace('{articleTitle}', encodeURIComponent(this.title))
                window.open(link, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=400')
            },
        }
    }
</script>
